<template>
  <span class="btn-filter-ctrl" :class="{'panel-open': filterStatus}">
    <div class="btn-wrap">
      <span>絞り込み</span>
    </div>
  </span>
</template>

<script>
export default {
  name: 'FilterButton',
  props: {
    filterStatus: {
      type: Boolean,
      default: false,
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.btn-filter-ctrl {
  position: relative;
  $btnHeight: 24px;
  .btn-wrap {
    width: 80px;
    height: $btnHeight;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    user-select: none;
    position: relative;
    z-index: 1;
    background: $col_def_gradient;
    border-radius: 32px;
    pointer-events: auto;
    transform-origin: right center;
    transition: all 300ms ease-in 0s;
    transform: scale(1, 1);
    &::before {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      box-sizing: border-box;
      border-radius: 2em;
      padding: 2px;
      width: 100%;
      height: 100%;
      background: #fff;
      background-clip: content-box;
      content: "";
    }

    & > span {
      color: mix($col_temp_key1, $col_temp_key2);
      font-weight: bold;
      font-size: 12px;
      line-height: 1;
      background: $col_def_gradient;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  &::before,
  &::after {
    content: "";
    position: absolute;
    width: $btnHeight * 1.0;
    height: 2px;
    background: $col_temp_key2;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: 10;
    opacity: 0;
    transition: all 300ms ease-out 0s;
    border-radius: 4px;
  }
  &::before {
    transform: scale(1.8, 1) rotate(0) translate(-10px, -($btnHeight / 2));
  }
  &::after {
    transform: scale(1.8, 1) rotate(0) translate(-10px, ($btnHeight / 2));
  }
  &.panel-open {
    .btn-wrap {
      transform: scale(0.9, 1);
      opacity: 0;
    }
    &::before,
    &::after {
      opacity: 1;
      background: #656D78;
    }
    &::before {
      transform: scale(1, 1) rotate(45deg) translate(0, 0);
    }
    &::after {
      transform: scale(1, 1) rotate(-45deg) translate(0, 0);
    }

  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Playlist/FilterButton.vue